<template>
  <div class="w3-container" style="margin: 0px; padding: 0px">
    <div v-if="add_br">
      <p style="padding: 20px"></p>
      <p></p>
      <p></p>
    </div>
    <h3>{{ sites.subtitle }}</h3>
    <p>{{ sites.summary }}</p>
    <div class="w3-bar">
      <div v-for="(site, page_index) in sites.sites" :key="page_index">
        <!-- buttons -->
        <button
          style="border-style: solid; border-width: 1px"
          class="w3-button w3-block w3-light-grey w3-left-align"
          :class="status[page_index] ? 'active_page' : 'not_active_page'"
          @click="toggle_status(page_index)"
        >
          <p class="w3-center">
            <strong>{{ site.name }} - {{ site.access }}</strong>
          </p>
        </button>

        <!-- tab contents -->
        <div
          class="w3-container w3-border room w3-animate-zoom"
          :class="status[page_index] ? 'w3-show' : 'w3-hide'"
        >
          <!--          <h3>{{ site.name }} - {{ site.access }}</h3>-->

            <span v-for="des in site.des" :key="des">{{ des }}&nbsp;</span>
          <!--<div class="image_container">-->
            <img style="margin:5px 0px 5px 0px" :src="site.photo" alt="" />
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed } from "vue";
import { language_util } from "@/classes/language/language_util.js";
import { info_utils } from "@/classes/info/info_utils.js";
export default {
  components: {},
  props: ["mode"],
  setup(props) {
    /*    const status = computed(() => {
      let size = sites.value.sites.length;
      let temp = initialize_my_array(size);
      console.log('temp')
      console.log(temp)
      return temp
    });*/

    const status = ref([false, false, false, false, false, false, false]);
    const add_br = ref(false);

    function initialize_my_array(size) {
      let temp = [],
        i = 0;
      for (i = 0; i < size; i++) {
        temp.push(false);
      }
      return temp;
    }

    const sites = computed(() => {
      if (props.mode == "tour") {
        return info_utils.get_tours_info(language.value);
      }
      if (props.mode == "restaurant") {
        add_br.value = true;
        return info_utils.get_restaurants_info(language.value);
      }
      if (props.mode == "shop") {
        add_br.value = true;
        return info_utils.get_shops_info(language.value);
      }
      if (props.mode == "super") {
        add_br.value = true;
        return info_utils.get_supers_info(language.value);
      }
    });
    const language = computed(() => {
      return language_util.get_language();
    });
    function toggle_status(index) {
      status.value[index] = !status.value[index];
    }
    function combine(myarray) {
      let temp = myarray.size;
      let temp2 = "";
      let i;
      console.log("temp2");
      console.log(myarray);
      for (i = 0; i < temp; i++) temp2 = temp2 + myarray[i];
      console.log("temp2");
      console.log(temp2);
      return temp2;
    }

    return {
      combine,
      status,
      add_br,
      toggle_status,
      sites,
      //openStation,
      //current_station,
    };
  },
};
</script>

<style scoped>
.active {
  color: red;
}

img {
  max-width: 100%;
  height: auto;
}

.blockClass {
  display: block;
}

.noneClass {
  display: none;
}
.active_page {
  background-color: red;
  color: white;
}
.not_active_page {
  background-color: black;
  color: white;
}
</style>
